
import * as defaultImport from "@splunk/themes/getSettingsFromThemedProps";
export * from "@splunk/themes/getSettingsFromThemedProps";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
